var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6381_9836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.28516 9.68541C1.28516 8.06916 1.28516 7.26104 1.78726 6.75894C2.28936 6.25684 3.09748 6.25684 4.71373 6.25684H9.28516C10.9014 6.25684 11.7095 6.25684 12.2116 6.75894C12.7137 7.26104 12.7137 8.06916 12.7137 9.68541C12.7137 11.3017 12.7137 12.1098 12.2116 12.6119C11.7095 13.114 10.9014 13.114 9.28516 13.114H4.71373C3.09748 13.114 2.28936 13.114 1.78726 12.6119C1.28516 12.1098 1.28516 11.3017 1.28516 9.68541Z",
    fill: "currentColor",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57129 6.25698V5.11412C3.57129 3.22057 5.10631 1.68555 6.99986 1.68555C8.89341 1.68555 10.4284 3.22057 10.4284 5.11412V6.25698",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6381_9836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7143,
    height: 13.7143,
    fill: "white",
    transform: "translate(0.142578 0.542969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFill);
export default __webpack_public_path__ + "static/media/lockFill.46967a1be4daf7a6501f3c546b44690f.svg";
export { ForwardRef as ReactComponent };